import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { fetchCompany } from '../actions';
import { selectCompany, selectCompanyProperty } from '../selectors';
import { CompanyLabel } from './CompanyLabel';
import { WithCompanyProperty } from './WithCompanyProperty';
import { isWithInstallation } from '../../Vehicles/helpers';
import { selectConfig } from '../../Api/selectors';
import { WIENTJES_INSTALATION } from '../../../containers/App/constants';

const Container = styled.div``;

const StyledCompanyLabel = styled.span`
  font-size: 14px;
  margin: 5px 5px 5px 5px;
  display: inline-block;

  /* Add more styles as needed */
`;

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class CompanyLabelByIdComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.company) {
      this.props.fetch();
    }
  }

  get name() {
    return this.props.transportCard && this.props.transport_to ? this.props.transport_to : this.props.companyName;
  }

  get surname() {
    return this.props.companySurName;
  }

  get companyPhone() {
    return this.props.companyPhone;
  }

  get countryCode() {
    return this.props.countryCode;
  }

  get isInstalation() {
    return isWithInstallation(this.props.config.appClientId, WIENTJES_INSTALATION.APP_CLIENT_NAME);
  }

  render() {
    //there are 2 ways to do this, either by fetching the entire company or by fetching the name property only ...

    if (this.props.fetchPhone) {
      return (
        <>
        <WithCompanyProperty key={'country_code'} company_id={this.props.company_id} property_name={'country_code'}>
        <span className="company-label">{this.countryCode} </span> &nbsp;
      </WithCompanyProperty>
        <WithCompanyProperty key={'phone_number'} company_id={this.props.company_id} property_name={'phone_number'}>
          <span className="company-label">{this.companyPhone} </span> &nbsp;
        </WithCompanyProperty>
        </>
      );
    }

    if (this.props.fetchName) {
      return (
        <>
          {['name', 'surname'].map(propertyName => {
            return (
              <WithCompanyProperty
                key={propertyName}
                isPropertyValue={this[propertyName]}
                company_id={this.props.company_id}
                property_name={propertyName}
              >
                <span className="company-label">{this[propertyName]} </span> &nbsp;
              </WithCompanyProperty>
            );
          })}
        </>
      );
    }

    if (!this.props.company) return null;

    if (this.props.order && this.isInstalation) {
      return <CompanyLabel company={this.props.company} withSurname={true} />;
    }
    return <CompanyLabel company={this.props.company} withSurname={true} />;
  }
}

CompanyLabelByIdComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    company: selectCompany(ownProps.company_id),
    companyName: selectCompanyProperty(ownProps.company_id, 'name'),
    companySurName: selectCompanyProperty(ownProps.company_id, 'surname'),
    companyPhone: selectCompanyProperty(ownProps.company_id, 'phone_number'),
    countryCode: selectCompanyProperty(ownProps.company_id, 'country_code'),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      if (!ownProps.company_id) return;
      if (ownProps.fetchName) return;
      if (ownProps.fetchPhone) return;
      if (ownProps.fetchSurName) return;

      dispatch(fetchCompany(ownProps.company_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyLabelById = compose(withConnect, withRouter)(CompanyLabelByIdComp);
